import type { FunctionComponent } from 'react';
import React from 'react';
import cx from 'classnames';
import { N40A } from '@trello/colors';
import { Board } from './Board';
import styles from './BoardCard.less';

export const PlaceholderCard: FunctionComponent<{ className?: string }> = ({
  className,
}) => (
  // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage -- EXCEPTION (static color, dynamic background)
  <Board className={cx(className, styles.placeholderBoard)} bgColor={N40A}>
    <div className={cx(styles.placeholderBar, styles.topPlaceholderBar)} />
    <div className={cx(styles.placeholderBar, styles.bottomPlaceholderBar)} />
  </Board>
);
